import React from 'react';
import { Box, Typography } from '@mui/material';
import '../../../resources/global.css';

const TotalValueCard = ({ total }) => {
  return (
    <Box
      sx={{
        width: '100%',
        boxSizing: 'border-box'
      }}>
      <Typography
        sx={{
          color: 'var(--ft-white)',
          fontSize: 'var(--ft-h2-font-size)',
          fontWeight: 'var(--ft-h2-font-weight)',
          fontFamily: 'var(--ft-h2-font-family)',
          letterSpacing: 'var(--ft-h2-letter-spacing)',
          lineHeight: 'var(--ft-h2-line-height)'
        }}>
        TOTAL VALUE
      </Typography>

      <Typography
        sx={{
          color: 'var(--ft-white)',
          fontFamily: 'var(--ft-h4-font-family)',
          fontSize: 'var(--ft-h4-font-size)',
          fontWeight: 'var(--ft-h4-font-weight)',
          lineHeight: 'var(--ft-h4-line-height)'
        }}>
        {total}
      </Typography>
    </Box>
  );
};

export default TotalValueCard;
